import { gql } from '@src/lib/gql'

/**
 * Founder-owned board seats. `statusKeys` is a variable so the Advisor Board
 * Seats rail can render all seats or one status per page (drafts / searching /
 * invited / filled) off a single document. An empty list means every status.
 */
export const BOARD_SEATS_ENGAGEMENTS = gql`
  query BoardSeatsSectionEngagements($statusKeys: [String], $pageSize: Int, $page: Int) {
    advisorEngagements(role: "FOUNDER", statusKeys: $statusKeys, pageSize: $pageSize, page: $page) {
      items {
        id
        advisorEngagementId
        categoryKey
        industryKeys
        skillTagTitles
        whyText
        statusKey
        candidateCount
        currentUserCanEdit
        invitedAt
        advisorUserId
        advisorName
        advisorEmail
        companyId
        sourceKey
        isAI
        compensationTypeKeys
        timeCommitmentTypeKeys
        advisorUser {
          id
          userId
          slug
          firstName
          lastName
          fullName
          displayName
          email
          title
          pictureUrl
          shortBio
          bio
          advisorProfile {
            id
            advisorProfileId
            headline
            bioForAdvising
          }
        }
        company {
          id
          companyId
          name
          logoUrl
        }
        groupRequest {
          id
          groupRequestId
          title
        }
        category {
          id
          key
          title
        }
        status {
          id
          key
          title
        }
        currentAgreement {
          id
          advisorAgreementId
          statusKey
          status {
            id
            key
            title
          }
        }
      }
      pagination {
        itemCount
        hasNextPage
        page
        pageCount
      }
    }
  }
`
